<template>
  <tr class="line-item-summary__item">
    <th v-if="item.total">
      {{ item.label }}
    </th>
    <td v-if="item.total">
      {{ formatPrice(item.total) }}
    </td>
  </tr>
</template>

<script>
import priceable from '~/mixins/priceable'

export default {
  name: 'PercentagePromotionItem',
  mixins: [priceable],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.line-item-summary__item {
  th,
  td {
    font-size: 15px;
    text-align: right;
    padding-bottom: 5px;
  }

  th {
    color: #a2a2a6;
    padding: 0 5px 0 0;
    font-weight: 400;
  }
}
</style>
